import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../supabase'
import { extractBillData } from '../../OCR'
import { getSignedUrl, parseDocumentAIEntities, parseLineItemsFromEntities } from '../../functions'
import { extractDataFromBills } from '../../api'
import { storeBillExtract } from '../../supabase/insertFunction'
import { useBills } from '../../hooks/useBills'
import { extractDataFromFile } from '../../gemini'

const Dashboard = () => {

    const { user } = useAuth()
    const [file, setFile] = useState(null)
    const [status, setStatus] = useState('')
    const [waiting, setWaiting] = useState(false)

    const { bills, loading, fetchBills } = useBills();
    const [lineItems, setLineItems] = useState([]);
    const [selectedBill, setSelectedBill] = useState(null);


    let billid = useRef()
    let suppliername = useRef()
    let paymenttype = useRef()
    let totalamount = useRef()
    let purchasedate = useRef()


    const handleFileChange = (e) => {
        setFile(e.target.files[0])
    }

    const handleUpload = async () => {
        try {


            setWaiting(true)

            if (!file || !user) {
                setStatus('Please select a file and make sure you are logged in.')
                setWaiting(false)
                return
            }

            setStatus('Uploading...')


            // Upload to storage
            const filePath = `${user.id}/${Date.now()}-${file.name}`
            const { data, error } = await supabase.storage
                .from('user-files')
                .upload(filePath, file, {
                    cacheControl: '3600',
                    upsert: false, // set true to allow overwrite
                    contentType: file.type
                })

            // console.log(data, "eerror upload");

            if (error) {
                setStatus(`Upload failed: ${error.message}`)
                return
            }

            // Get public URL (if needed) or create signed URL later
            const { data: urlData } = supabase.storage
                .from('user-files')
                .getPublicUrl(filePath)


            // Save metadata to database
            const { data: storedata, error: dbError } = await supabase
                .from('file_uploads')
                .insert([{
                    user_id: user?.id,
                    file_name: file?.name,
                    file_url: urlData.publicUrl, // or store just filePath for private access
                }])
                .select()
                .single()


            // console.log(storedata)

            let impData = {
                upload_id: storedata.id,
                user_id: storedata.user_id
            }

            // console.log(impData);



            if (dbError) {
                setStatus(`Metadata save failed: ${dbError.message}`)
                return
            }

            setStatus('File uploaded and logged successfully!')

            let input = {
                filePath: data.path,
                mimeType: file.type
            }


            let mainresult = await extractDataFromFile(file)
            console.log(mainresult, "mmmm")


            let finalobj = {
                upload_id: impData.upload_id,
                user_id: user.id,
                bill_id: mainresult.bill_id,
                supplier_name: mainresult.supplier_name,
                supplier_address: mainresult.supplier_address,
                supplier_city: mainresult.supplier_city,
                supplier_phone: mainresult.supplier_phone,
                receipt_date: mainresult.receipt_date,
                total_amount: mainresult.total_amount,
                net_amount: mainresult.net_amount,
                total_tax_amount: mainresult.total_tax_amount,
                currency: mainresult.currency,
                payment_type: mainresult.payment_type,
                credit_card_last4: mainresult.credit_card_last4,
            };

            console.log(finalobj, "fff")


            // Check if this bill_id already exists for this user
            const { data: existingBill, error: checkError } = await supabase
                .from("bill_extracts")
                .select("*")
                .eq("bill_id", finalobj.bill_id)
                .eq("user_id", user.id)
                .maybeSingle();

            if (checkError) throw checkError;

            if (existingBill) {
                alert("Duplicate bill already stored.");
                window.location.reload()
                return { success: false, message: "Bill already exists." };
            }


            // let storeData = await storeBillExtract(result, impData)

            const result = await supabase
                .from('bill_extracts')
                .insert(finalobj)
                .select()
                .single();

            console.log(result, "rrr")

            let billId = result.data.id


            // 2. Insert line items
            const lineItemPayload = mainresult.line_items.map((item) => ({
                bill_id: billId,
                item: item.item,
                price: item.price
            }));

            const { error: lineItemError } = await supabase
                .from('bill_line_items')
                .insert(lineItemPayload);

            if (lineItemError) {
                console.error('Error inserting line items:', lineItemError);
            }

            // 3. Insert recommendations
            const recommendationPayload = mainresult.recommendations.map((rec) => ({
                bill_id: billId,
                item: rec.item,
                actual_price: rec.actual_price,
                recommended_price: rec.recommended_price,
                estimated_savings: rec.estimated_savings,
                store_name: rec.store_name,
                store_address: rec.store_address,
                user_id: user.id,
            }));

            const { error: recError } = await supabase
                .from('bill_recommendations')
                .insert(recommendationPayload);

            if (recError) {
                console.error('Error inserting recommendations:', recError);
            }

            if (result.status == 201) {
                fetchBills()
                setWaiting(false)
                setFile(null)
                window.location.reload()
            }


        } catch (error) {
            console.error("error storing bills", error)
            return { success: false, message: error.message }
        }

    }


    const openModalWithLineItems = async (bill) => {
        setSelectedBill(bill);
        const { data, error } = await supabase
            .from("bill_line_items")
            .select("*")
            .eq("bill_id", bill.id);

        if (error) {
            console.error("Error fetching line items:", error);
            setLineItems([]);
        } else {
            setLineItems(data);
        }

        const modal = new window.bootstrap.Modal(document.getElementById("lineItemsModal"));
        modal.show();
    };

    const saveBillManuall = async () => {

        let bid = billid.current.value
        let supplier = suppliername.current.value.toUpperCase()
        let total = totalamount.current.value
        let payment = paymenttype.current.value.toUpperCase()
        let date = purchasedate.current.value

        let data = {
            bill_id: bid,
            user_id: user.id,
            supplier_name: supplier,
            total_amount: total,
            payment_type: payment,
            receipt_date: date
        }

        console.log(data, "Ddd")


        const result = await supabase
            .from('bill_extracts')
            .insert(data)
            .select()
            .single();

        window.location.reload()

        fetchBills()

        console.log(result, "rrr")
    }

    // if (loading) return <p>Loading...</p>;



    return (

        <div className='container-fluid main' style={{ marginTop: '120px' }}>
            {!bills.length && 'No Bills found'}
            <div className='d-flex '>
                <div class="container mt-5">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="card" style={{ width: '18rem' }}>
                                <div class="card-body">
                                    <h3 class="card-title text-dark">Upload a file</h3>
                                    <h6 class="card-subtitle mb-2 text-muted">png,jpg,pdf</h6>
                                    <input type="file" onChange={handleFileChange} />
                                    <br /><br />
                                    <button className='btn btn-large btn-dark' disabled={waiting} onClick={handleUpload}>{waiting ? 'in Progress' : 'upload'}</button>
                                    <p>{status}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container mt-5">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="card" style={{ width: '18rem' }}>
                                <div class="card-body">
                                    <h3 class="card-title text-dark">Add Manual Bill</h3>
                                    <div class="mb-3">
                                        <label for="exampleInputEmail1" class="form-label" >Bill Id</label>
                                        <input class="form-control" required ref={billid} />
                                    </div>
                                    <div class="mb-3">
                                        <label for="exampleInputEmail1" class="form-label" >Supplier Name</label>
                                        <input class="form-control" required ref={suppliername} />
                                    </div>
                                    <div class="mb-3">
                                        <label for="exampleInputEmail1" class="form-label" >Total Amount</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            class="form-control"
                                            required
                                            ref={totalamount}
                                        />
                                    </div>
                                    <div class="mb-3">
                                        <label for="exampleInputEmail1" class="form-label" >purchase date</label>
                                        <input
                                            type="date"
                                            step="0.01"
                                            class="form-control"
                                            required
                                            min="2000-01-23"
                                            ref={purchasedate}
                                        />
                                    </div>
                                    <div class="mb-4">
                                        <label for="exampleInputEmail1" class="form-label">Payment Type</label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            required
                                            ref={paymenttype}
                                        />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <button className="btn bg-dark text-white" onClick={saveBillManuall}>Save bill</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {bills.length && (
                <div className='container-fluid mt-5'>

                    <table class="table text-dark">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>bill No</th>
                                <th>Supplier</th>
                                <th>Total</th>
                                <th>Net</th>
                                <th>Tax</th>
                                <th>Date</th>
                                <th>Payment</th>
                                <th>Currency</th>
                                <th>Items</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bills.map((bill, ind) => (
                                <tr key={bill.id}>
                                    <td>{ind + 1}</td>
                                    <td>{bill.bill_id}</td>
                                    <td>{bill.supplier_name}</td>
                                    <td>{bill.total_amount}</td>
                                    <td>{bill.net_amount}</td>
                                    <td>{bill.total_tax_amount}</td>
                                    <td>{bill.receipt_date}</td>
                                    <td>{bill.payment_type}</td>
                                    <td>{bill.currency}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => openModalWithLineItems(bill)}
                                        >
                                            View Items
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            )}

            <div
                className="modal fade"
                id="lineItemsModal"
                tabIndex="-1"
                aria-labelledby="lineItemsModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="lineItemsModalLabel">
                                Line Items for {selectedBill?.supplier_name}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            {lineItems.length === 0 ? (
                                <p>No line items found.</p>
                            ) : (
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lineItems.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.item}</td>
                                                <td>${item.price.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}

export default Dashboard